<template>
<ViskaseCard>
    <template v-slot:header>
    </template>
    <template v-slot:title>
    </template>
    <template v-slot:default>
        <div class="row px-2">
            <div class="col text-start">
                <div v-html="making" class="h3"> 
                </div>
                <div>
                    <ul>
                        <li v-for="(item, index) in selectedSolution.reasons" :key="index">
                            {{ item.desc }}
                        </li>
                    </ul>
                </div>
            </div>
        </div>
        <div class="row px-2">
            <div class="col text-start">
                <div v-html="please_choose_one" class="h3">
                </div>
            </div>
        </div>
        <div class="row">
            <div class="col-12 col-xs-12 col-sm-12 col-md-6 col-lg-6 col-xl-4  " v-for="(item, index) in activeCasings" :key="index">
                <div class="p-1" @click="gotoCasing(item)">
                    <button type="button" class="m-1 btn btn-viskase">
                        {{ item.alias }}
                    </button>
                </div>
            </div>
        </div>
    </template>
    <template v-slot:footer>
    </template>
</ViskaseCard>
</template>

<script>
import { mapState, mapActions, mapMutations } from "vuex";
import ViskaseCard from "@/components/core/ViskaseCard.vue";
export default {
  name: "GroupCasings",
  components: {
    ViskaseCard,
  },
  data() {
    return {};
  },
  watch: {
    selectedCasing() {
      if (!this.selectedCasing.id) return;
      var selectedSolutionCasings = this.solutionCasings.find(
        (x) => x.solutionId === this.selectedSolution.id
      ) || {
        casings: [],
      };
      var selectedLinks = (
        this.casingLinks.find((x) => x.casingId === this.selectedCasing.id) || {
          links: [],
        }
      ).links.map((x) => {
        var casing = {
          ...this.casings.find((z) => z.id === x),
          ...selectedSolutionCasings,
        };
        return casing;
      });

      this.setSelectedLinks(selectedLinks);
    },
  },
  mounted() {},
  methods: {
    ...mapActions(["fetchCasings", "fetchSolutionCasings", "fetchCasingLinks"]),
    ...mapMutations(["setSelectedCasing", "setSelectedLinks"]),
    gotoFeatures(casing) {
      this.setSelectedCasing(casing);
      if (casing.variant === "features") {
        this.$router.push({
          name: "features",
          params: {
            language: this.$route.params.language,
            product: this.$route.params.product,
            solution: this.$route.params.solution,
            casing: casing.name,
          },
        });
      }
    },

    gotoCasing(casing) {
      this.setSelectedCasing(casing);
      this.$router.push({
        name: "casings",
        params: {
          language: this.$route.params.language,
          product: this.$route.params.product,
          solution: this.$route.params.solution,
          casing: casing.name,
        },
      });
    },
  },
  computed: {
    ...mapState([
      "casings",
      "selectedProduct",
      "selectedSolution",
      "selectedCasing",
      "solutionCasings",
      "casingLinks",
      "activeCasings",
      "selectedLinks",
      "cards",
    ]),
    please_choose_one() {
      return this.cards.groupCasings.please_choose_one
        .replace(
          /{selectedSolution}/g,
          "<span class='viskase-orange-text fw-bold'>" +
            (this.selectedSolution || {}).title +
            "</span>"
        )
        .replace(
          /{selectedProduct}/g,
          "<span class='viskase-orange-text fw-bold'>" +
            (this.selectedProduct || {}).title +
            "</span>"
        );
    },
    making() {
      return this.cards.groupCasings.making
        .replace(
          /{selectedSolution}/g,
          "<span class='viskase-orange-text fw-bold'>" +
            (this.selectedSolution || {}).title +
            "</span>"
        )
        .replace(
          /{selectedProduct}/g,
          "<span class='viskase-orange-text fw-bold'>" +
            (this.selectedProduct || {}).title +
            "</span>"
        );
    },
  },
};
</script>

<style scoped></style>
